<template>
    <div class="m-team-view">
        <div class="team-pannel">
            <h5 class="title"></h5>

            <div class="team-code">队伍码 : {{ team_code || '----' }}</div>

            <userinfo class="user-info"/>

            <div class="team-info-view">
                <div class="team-list">
                    <ul>
                        <li v-for="(item,index) in teaminfo" :key="item.uid">
                            <div class="avatar act">
                                <div class="label-leader" v-if="$store.state.cid == item.uid"></div>
                                <img :src="require('@/assets/images/avatar/'+ (index + 1) +'.jpg')" :alt="item.uid">
                            </div>
                            <p class="player-name">{{ item.name }}</p>
                        </li>                        
                        <li v-for="n in (5 - teaminfo.length)" :key="n">
                            <div class="avatar u-btn" @click="call_team_invite"></div>
                            <p class="player-name">暂无</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="u-btn invite" @click="call_team_invite"></div>
            <div class="u-btn team-detail" @click="call_team_detail"></div>
            <div class="u-btn reflash" :class="{'act' : ajax_busy}" @click="init(1)"><span>刷新队伍状态</span></div>
        </div>

        <div class="team-shop">
            <h5 class="title"></h5>

            <div class="reward-info">
                <div class="reward-pannel aniver-pack">
                    <div class="warpper">
                        <h6 class="title t-1"></h6>
                        <div class="game-item">
                            <div class="pack-icon"
                            v-tips="'ML74'">
                                <game-item :id="'ML74'" :num="1" :locked="true"></game-item>
                            </div>
                        </div>

                        <div class="u-btn apply" :class="{'disabled' : teaminfo.length != max,'dismiss' : $store.state.account.team == 9}" @click="apply_ani_pack"></div>
                    </div>
                </div>
                <div class="reward-pannel lottery">
                    <div class="wrapper">
                        <h6 class="title t-2"></h6>
                        <div class="reward-list">
                            <div class="icon-sp" v-tips="'J155'">
                                <img v-if="$global.deviceType == 'pc'" :src="require('@/assets/images/icons/cSP.png')">
                                <img v-else :src="require('@/assets/images/icons_m/cSP.png')">
                            </div>
                            <ul>
                                <li v-for="(item,index) in tips" :key="item">
                                    <div class="pic-icon" v-tips="item">
                                        <img v-if="$global.deviceType == 'pc'" :src="require('@/assets/images/icons/c' + (index + 1) + '.png')">
                                        <img v-else :src="require('@/assets/images/icons_m/c' + (index + 1) + '.png')">
                                    </div>
                                </li>
                                <li v-for="k in 8" :key="k">
                                    <div class="pic-icon">
                                        <img v-if="$global.deviceType == 'pc'" :src="require('@/assets/images/icons/c' + (k+4) + '.png')">
                                        <img v-else :src="require('@/assets/images/icons_m/c' + (k+4) + '.png')">
                                    </div>
                                </li>                                
                            </ul>
                            <!-- <div class="tbc"></div> -->
                        </div>
                        <div class="lottery-code">
                            <div class="my-code">{{ lottery_code || '----' }}</div>
                            <div class="result-code">
                                <span v-if="!result.length">待揭晓</span>
                                <span class="u-btn" v-else @click="$result_modal({result_config : result})">点击查看</span>
                            </div>
                            
                            <div class="tips-win" v-if="result.length && is_Luck(lottery_code) && lottery_code"></div>
                            <div class="tips-lose" v-if="result.length && !is_Luck(lottery_code) && lottery_code"></div>
                        </div>
                    </div>
                    <!-- <p class="notice">点击图片查看详情</p> -->
                </div>
            </div>


            <div class="shop-view">
                <div class="shop-item">
                    <h6 class="title t-1"></h6>

                    <div class="gift-list">
                        <ul>
                            <li v-for="(item,index) in team_pack" :key="index"
                            v-tips="item.id">
                                <div class="pack-icon">
                                    <game-item :id="item.id" :num="item.num" :locked="true"></game-item>
                                </div>                               
                            </li>
                        </ul>
                    </div>

                    <div class="u-btn apply" :class="{'disabled' : teaminfo.length != max || $store.state.teamdata.teamBoon == 0, 'dismiss' : $store.state.teamdata.teamBoon == 9}" @click="apply"></div>
                </div>
                <div class="shop-item">
                    <h6 class="title t-2"></h6>

                    <div class="gift-list">
                        <ul>
                            <li v-for="(item,index) in shop_list" :key="index"
                            v-tips="item.id">
                                <div class="pack-icon">
                                    <game-item :id="item.id" :num="item.num" :locked="true"></game-item>
                                </div>  
                            </li>
                        </ul>
                    </div>
                    <div class="u-btn buy" :class="{'disabled' : teaminfo.length != max || $store.state.teamdata.teamBuy == 0, 'dismiss' : $store.state.teamdata.teamBuy == 9}" @click="buy"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<style lang="scss" scoped>
.team-pannel{
    @media screen and (min-width: 900px) {
        position: relative;
        width: 1347px;
        height: 801px;
        margin: 0 auto;
        padding: 88px 85px 0;
        box-sizing: border-box;
        background-image: url(~@/assets/images/pc/team-pannel.png);

        .title{
            width: 803px;
            height: 95px;
            margin: 0 auto 25px;
            background-image: url(~@/assets/images/pc/title-1.png);
        }

        .team-code{
            width: 345px;
            height: 71px;
            line-height: 71px;
            text-align: center;
            color: #be3f14;
            font-weight: 700;
            font-size: 28px;
            margin: 0 auto 15px;
            background-image: url(~@/assets/images/pc/bg-team_code.png);            
        }

        .team-info-view{
            width: 1164px;
            height: 332px;
            margin: 0 auto;
            background-image: url(~@/assets/images/pc/bg-team_list.png);            
        }

        .team-list ul{
            display: flex;
            justify-content: space-between;
            padding: 23px 75px 0;

            .avatar{
                position: relative;
                width: 148px;
                height: 148px;
                background-image: url(~@/assets/images/pc/bg-player_item.png);

                &.act{
                    width: 150px;
                    height: 150px;
                    background-image: url(~@/assets/images/pc/bg-avatar.png);                    
                }

                img{
                    display: block;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 130px;
                    height: 130px;
                    border-radius: 15px;
                    transform: translate(-50%,-50%);                    
                }

                .label-leader{
                    position: absolute;
                    top: -5px;
                    left: -5px;
                    width: 26px;
                    height: 68px;
                    background-image: url(~@/assets/images/pc/label-leader.png);
                    z-index: 5;
                }                
            }

            .player-name{
                margin-top: 17px;
                font-size: 18px;
                font-weight: 700;
                color: #d96540;
                text-align: center;
            }          
        }

        .u-btn.invite{
            width: 314px;
            height: 124px;
            margin: -90px auto 0;
            background-image: url(~@/assets/images/pc/btn-invite.png);             
        }

        .u-btn.team-detail{
            position: absolute;
            right: 47px;
            bottom: 82px;
            width: 151px;
            height: 48px;
            background-image: url(~@/assets/images/pc/btn-team_detail.png);
            
            &::after{
                content: '';
                display: block;
                position: absolute;
                left: -50px;
                top: -50px;
                width: 44px;
                height: 47px;
                background-image: url(~@/assets/images/pc/icon-panda.png);
                animation: toptobotm1 2s ease-in-out infinite;
            }
        }
        
        .u-btn.reflash{
            position: absolute;
            right: 80px;
            top: 90px;
            width: 33px;
            height: 32px;
            background-image: url(~@/assets/images/pc/btn-reflash.png);
            
            span{
                position: absolute;
                left: -150px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 24px;
                color: #ca7863;
                font-family: 'HYJinKaiJ';;
            }
        }
    }

    //mobile
    @media screen and (max-width: 899px) {
        position: relative;
        width: 750px;
        height: 793px;
        margin: 0 auto;
        padding: 68px 0 0;
        box-sizing: border-box;
        background-image: url(~@/assets/images/m/team-pannel.png);

        .title{
            width: 705px;
            height: 106px;
            margin: 0 auto 25px;
            background-image: url(~@/assets/images/m/title-1.png);
        }

        .team-code{
            width: 345px;
            height: 71px;
            line-height: 71px;
            text-align: center;
            color: #be3f14;
            font-weight: 700;
            font-size: 28px;
            margin: 0 auto 15px;
            background-image: url(~@/assets/images/pc/bg-team_code.png);            
        }

        .team-info-view{
            // width: 1164px;
            // height: 332px;
            // margin: 0 auto;
            // background-image: url(~@/assets/images/pc/bg-team_list.png);            
        }

        .team-list ul{
            display: flex;
            justify-content: space-between;
            padding: 23px 18px 0;

            .avatar{
                position: relative;
                width: 122px;
                height: 121px;
                background-image: url(~@/assets/images/m/bg-player_item.png);

                &.act{
                    width: 122px;
                    height: 122px;
                    background-image: url(~@/assets/images/m/bg-avatar.png);                    
                }

                img{
                    display: block;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 110px;
                    height: 110px;
                    border-radius: 15px;
                    transform: translate(-50%,-50%);                    
                }

                .label-leader{
                    position: absolute;
                    top: -5px;
                    left: -5px;
                    width: 22px;
                    height: 55px;
                    background-image: url(~@/assets/images/m/label-leader.png);
                    z-index: 5;
                }                
            }

            .player-name{
                width: 110px;
                margin: 17px auto 0;
                word-break: break-all;
                font-size: 18px;
                font-weight: 700;
                color: #d96540;
                text-align: center;
            }          
        }

        .u-btn.invite{
            width: 314px;
            height: 124px;
            margin: 10px auto 0;
            background-image: url(~@/assets/images/pc/btn-invite.png);             
        }

        .u-btn.team-detail{
            position: absolute;
            right: 9px;
            bottom: 75px;
            width: 151px;
            height: 48px;
            background-image: url(~@/assets/images/pc/btn-team_detail.png);
            
            &::after{
                content: '';
                display: block;
                position: absolute;
                left: -50px;
                top: -50px;
                width: 44px;
                height: 47px;
                background-image: url(~@/assets/images/pc/icon-panda.png);
                animation: toptobotm1 2s ease-in-out infinite;
            }
        }
        
        .u-btn.reflash{
            position: absolute;
            right: 30px;
            top: 50px;
            width: 33px;
            height: 32px;
            background-image: url(~@/assets/images/pc/btn-reflash.png);
            
            span{
                position: absolute;
                left: -150px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 24px;
                color: #ca7863;
                font-family: 'HYJinKaiJ';;
            }            

        }        
    }
}

.user-info{
    margin-bottom: 25px;
    text-align: center;
    font-size: 16px;
    color: #8b503b;

    @media screen and (max-width: 899px) {
        font-size: 24px;
    }
}

.team-shop{
    @media screen and (min-width: 900px) {
        h5.title{
            width: 648px;
            height: 65px;
            margin: 0 auto 25px;
            background-image: url(~@/assets/images/pc/team-gift.png);            
        }

        .game-item{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 104px;
            height: 105px;
            margin: 0 auto;
            background-image: url(~@/assets/images/pc/bg-item.png);

            .pack-icon{
                width: 46px;
                height: 46px;
            }
        }

        .reward-info{
            display: flex;
            justify-content: space-between;
            width: 1287px;
            margin: 0 auto;

            .reward-pannel{
                position: relative;
                width: 628px;
                height: 373px;
                padding-top: 30px;
                box-sizing: border-box;                
                margin-bottom: 27px;
                background-image: url(~@/assets/images/pc/bg-team_gift_item.png);
                
                .reward-list{
                    display: flex;
                    width: 494px;
                    height: 124px;
                    margin: 24px auto 0;
                    padding: 10px 28px 0 28px;
                    box-sizing: border-box;
                    background-image: url(~@/assets/images/pc/luck-pannel.png);

                    .icon-sp{
                        margin-top: 2px;
                    }

                    li{
                        margin: 0 0 8px 10px;
                    }
                }
            }

            .reward-pannel ul{
                display: flex;
                flex-wrap: wrap;
            }

            .lottery-code{
                position: relative;
                display: flex;
                justify-content: space-between;
                width: 434px;
                margin: 24px auto 0;
            }

            .lottery-code .tips-win{
                position: absolute;
                right: 15px;
                bottom: -20px;
                width: 137px;
                height: 20px;
                background-image: url(~@/assets/images/pc/notice-lottery_act.png); 
            }

            .lottery-code .tips-lose{
                position: absolute;
                right: 15px;
                bottom: -20px;
                width: 153px;
                height: 20px;
                background-image: url(~@/assets/images/pc/notice-lottery_dismiss.png); 
            }

            .result-code{
                width: 199px;
                height: 41px;
                line-height: 41px;
                margin-bottom: 12px;
                padding-left: 100px;
                box-sizing: border-box;
                font-size: 16px;
                font-weight: 700;
                color: #d96540;       
                background-image: url(~@/assets/images/pc/bg-lottery_result.png); 
            }

            .my-code{
                width: 199px;
                height: 41px;
                line-height: 41px;
                margin-bottom: 12px;
                padding-left: 100px;
                box-sizing: border-box;
                font-size: 22px;
                font-weight: 700;
                color: #d96540;
                background-image: url(~@/assets/images/pc/bg-lottery_code.png); 
            }

            .lottery .notice{
                position: absolute;
                left: 192px;
                top: 186px;
                font-size: 16px;
                color: #a1837d;
            }


            h6.title{
                width: 100%;
                height: 65px;
                margin: 0 auto;
                background-repeat: no-repeat;
                background-position: top center;

                &.t-1{
                    margin-bottom: 40px;
                    background-image: url(~@/assets/images/pc/team-gift-1.png);  
                }

                &.t-2{
                    background-image: url(~@/assets/images/pc/team-gift-2.png);  
                }                
            }

            .u-btn.apply{
                position: absolute;
                left: 50%;
                bottom: 35px;
                width: 222px;
                height: 66px;
                margin-left: -111px;
                background-image: url(~@/assets/images/pc/btn-apply.png);
                
                &.dismiss{
                    background-image: url(~@/assets/images/pc/btn-apply_dismiss.png);
                }
                
                &.disabled{
                    background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                }                     
            }
        }

        .shop-view{
            display: flex;
            justify-content: space-between;
            width: 1287px;
            margin: 0 auto;

            .shop-item{
                position: relative;
                width: 628px;
                height: 373px;
                padding-top: 30px;
                box-sizing: border-box;                    
                background-image: url(~@/assets/images/pc/bg-team_gift_item.png);
                
                h6.title{
                width: 100%;
                height: 65px;
                margin: 0 auto 38px;
                background-repeat: no-repeat;
                background-position: top center;

                    &.t-1{
                        background-image: url(~@/assets/images/pc/team-gift-3.png);  
                    }

                    &.t-2{
                        background-image: url(~@/assets/images/pc/team-gift-4.png);  
                    }                
                }
                
                .gift-list ul{
                    display: flex;
                    justify-content: space-between;
                    padding: 0 50px;
                    
                    li{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 104px;
                        height: 105px;
                        margin: 0 auto;
                        background-image: url(~@/assets/images/pc/bg-item.png);

                        .pack-icon{
                            width: 46px;
                            height: 46px;
                        }                        
                    }
                }

                .u-btn.apply{
                    position: absolute;
                    left: 50%;
                    bottom: 35px;
                    width: 222px;
                    height: 66px;
                    margin-left: -111px;
                    background-image: url(~@/assets/images/pc/btn-apply.png);
                    
                    &.dismiss{
                        background-image: url(~@/assets/images/pc/btn-apply_dismiss.png);
                    }
                    
                    &.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                    }                         
                }
                
                .u-btn.buy{
                    position: absolute;
                    left: 50%;
                    bottom: 35px;
                    width: 222px;
                    height: 66px;
                    margin-left: -111px;
                    background-image: url(~@/assets/images/pc/btn-buy19.png);
                    
                    &.dismiss,&.disabled{
                        background-image: url(~@/assets/images/pc/btn-buy19_disabled.png);
                    }                     
                }                   
            }
        }        
    }

    @media screen and (max-width: 899px) {
        h5.title{
            width: 648px;
            height: 65px;
            margin: 0 auto 25px;
            background-image: url(~@/assets/images/pc/team-gift.png);            
        }

        .game-item{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 104px;
            height: 105px;
            margin: 0 auto;
            background-image: url(~@/assets/images/pc/bg-item.png);

            .pack-icon{
                width: 46px;
                height: 46px;
            }
        }

        .reward-info{
            .reward-pannel{
                position: relative;
                width: 628px;
                height: 373px;
                padding-top: 30px;
                box-sizing: border-box;                
                margin: 0 auto 27px;
                background-image: url(~@/assets/images/pc/bg-team_gift_item.png);

                .icon-sp{
                    margin-top: -12px;
                }
                
                .reward-list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 564px;
                    height: 144px;
                    margin: 24px auto 0;
                    padding: 12px 5px 0 20px;
                    box-sizing: border-box;
                    background-image: url(~@/assets/images/m/luck-pannel.png);

                    li{
                        margin: 0 12px 12px 0;
                    }
                }
            }

            .reward-pannel ul{
                display: flex;
                flex-wrap: wrap;
                margin-left: 15px;
            }

            .lottery-code{
                position: relative;
                display: flex;
                justify-content: space-between;
                width: 434px;
                margin: 24px auto 0;
            }

            .lottery-code .tips-win{
                position: absolute;
                right: 15px;
                bottom: -20px;
                width: 137px;
                height: 20px;
                background-image: url(~@/assets/images/pc/notice-lottery_act.png); 
            }

            .lottery-code .tips-lose{
                position: absolute;
                right: 15px;
                bottom: -20px;
                width: 153px;
                height: 20px;
                background-image: url(~@/assets/images/pc/notice-lottery_dismiss.png); 
            }

            .result-code{
                width: 199px;
                height: 41px;
                line-height: 41px;
                margin-bottom: 12px;
                padding-left: 100px;
                box-sizing: border-box;
                font-size: 16px;
                font-weight: 700;
                color: #d96540;       
                background-image: url(~@/assets/images/pc/bg-lottery_result.png); 
            }

            .my-code{
                width: 199px;
                height: 41px;
                line-height: 41px;
                margin-bottom: 12px;
                padding-left: 100px;
                box-sizing: border-box;
                font-size: 22px;
                font-weight: 700;
                color: #d96540;
                background-image: url(~@/assets/images/pc/bg-lottery_code.png); 
            }

            .lottery .notice{
                position: absolute;
                left: 192px;
                top: 186px;
                font-size: 16px;
                color: #a1837d;
            }


            h6.title{
                width: 100%;
                height: 65px;
                margin: 0 auto;
                background-repeat: no-repeat;
                background-position: top center;
                background-size: auto 65px;

                &.t-1{
                    width: 450px;
                    margin-bottom: 40px;
                    background-image: url(~@/assets/images/m/team-gift-1.png);  
                }

                &.t-2{
                    background-image: url(~@/assets/images/m/team-gift-2.png);  
                }                
            }

            .u-btn.apply{
                position: absolute;
                left: 50%;
                bottom: 35px;
                width: 222px;
                height: 66px;
                margin-left: -111px;
                background-image: url(~@/assets/images/pc/btn-apply.png);
                
                &.dismiss{
                    background-image: url(~@/assets/images/pc/btn-apply_dismiss.png);
                }
                
                &.apply.disabled{
                    background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                }                     
            }
        }

        .shop-view{

            .shop-item{
                position: relative;
                width: 628px;
                height: 373px;
                padding-top: 30px;
                margin: 0 auto 30px;
                box-sizing: border-box;                    
                background-image: url(~@/assets/images/pc/bg-team_gift_item.png);
                
                h6.title{
                width: 100%;
                height: 65px;
                margin: 0 auto 38px;
                background-repeat: no-repeat;
                background-position: top center;

                    &.t-1{
                        background-image: url(~@/assets/images/pc/team-gift-3.png);  
                    }

                    &.t-2{
                        background-image: url(~@/assets/images/pc/team-gift-4.png);  
                    }                
                }
                
                .gift-list ul{
                    display: flex;
                    justify-content: space-between;
                    padding: 0 50px;
                    
                    li{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 104px;
                        height: 105px;
                        margin: 0 auto;
                        background-image: url(~@/assets/images/pc/bg-item.png);

                        .pack-icon{
                            width: 46px;
                            height: 46px;
                        }                        
                    }
                }

                .u-btn.apply{
                    position: absolute;
                    left: 50%;
                    bottom: 35px;
                    width: 222px;
                    height: 66px;
                    margin-left: -111px;
                    background-image: url(~@/assets/images/pc/btn-apply.png);
                    
                    &.dismiss{
                        background-image: url(~@/assets/images/pc/btn-apply_dismiss.png);
                    }
                    
                    &.apply.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                    }                         
                }
                
                .u-btn.buy{
                    position: absolute;
                    left: 50%;
                    bottom: 35px;
                    width: 222px;
                    height: 66px;
                    margin-left: -111px;
                    background-image: url(~@/assets/images/pc/btn-buy19.png);
                    
                    &.dismiss,&.disabled{
                     background-image: url(~@/assets/images/pc/btn-buy19_disabled.png);
                    }                          
                }
                
             
            }
        }            
    }
}
</style>

<script>
import userinfo from '@/components/userinfo'

export default {
    components: {
        userinfo,
    },
    mounted (){
        this.init();
        this.get_luck_list();
    },     
    data (){
        return {
            team_code : '',
            lottery_code : '',
            ajax_busy : false,
            teaminfo : [],
            max : 5,
            gift_list : [{id : 'FL70',name : ''},{id : 'FN22',name : ''},{id : 'FN38',name : ''},{id : 'FL70',name : ''},{id : 'FN22',name : ''},{id : 'FN38',name : ''},{id : 'FL70',name : ''},{id : 'FN22',name : ''},{id : 'FL70',name : ''},{id : 'FN22',name : ''},],
            team_pack : [{id : 'AN07',name : '',num : 2},{id : 'LE95',name : '',num : 3},{id : 'MI33',name : '',num : 5},],
            shop_list : [{id : 'D355',name : '',num : 1},{id : 'KW99',name : '',num : 5},{id : 'ML73',name : '',num : 1},],
            result : [],
            tips : ['FS16','FP88','FL74','FN72'],
        }
    },
    methods : {
        init (type){
            let refresh = type ? 'refresh' : 'init';
            this.$axios.get(ajax_url_map.teaminfo,{
                params : {
                    refresh : refresh
                }
            })
            .then(
                res => {
                    if(res.code != 0)return this.$store.commit("$_setCid", -1);

                    if(type)this.$toast('刷新成功~');
                    this.teaminfo = res.data.teamMember;
                    this.team_code = res.data.teamId;
                    this.lottery_code = res.data.teamLucky;

                    let cid = res.data.captainId ? res.data.captainId : -1;

                    this.$store.commit("$_setTeam", res.data.teamMember);
                    this.$store.commit("$_setCid", cid);
                    this.$store.commit("$_setTeamData", res.data);
                },
                rej => {
                    //this.$toast(rej.message);
                    this.$store.commit("$_setCid", -1);
                }
            )
        },
        update(){
            this.init(1);
        },
        get_luck_list(){
            this.$axios.get(ajax_url_map.luck_list)
            .then(
                res => {
                    this.result = res.data;
                },
                rej => {}
            )
        },
        call_team_invite (){

            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();

            if(!this.teaminfo.length)return this.$warn_modal();
            
            if(this.teaminfo.length == this.max)return this.$msg_modal({text : '你的小队人数已满，快去收集燃梦火炬兑换奖励吧！'});

            this.$share_modal();
        },
        call_team_detail (){

            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();

            return this.$team_info_modal({max : this.max});

            if(!this.teaminfo.length)return this.$warn_modal();
            
            //this.$share_modal();
            this.$team_info_modal();
        },
        apply (){
            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();

            if(this.teaminfo.length != this.max)return this.$toast('当前不符合领奖条件哦~');


            //team_gift_week
            this.$axios.get(ajax_url_map.team_gift_week)
            .then(
                res => {
                    this.$msg_modal({'text' : '领取成功，奖励已发放至对应账号的军师邮件中，请注意查收。'});
                    this.$update_team(); 
                },
                rej => {
                    this.$toast(rej.message);
                }
            )            
        },
        apply_ani_pack (){
            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();

            if(this.teaminfo.length != this.max)return this.$toast('当前不符合领奖条件哦~');

            //team_gift_week
            this.$axios.get(ajax_url_map.team_gift)
            .then(
                res => {
                    this.$msg_modal({'text' : '领取成功，奖励已发放至对应账号的军师邮件中，请注意查收。'});
                    this.$store.commit("$_setAniFlag", 9);
                },
                rej => {
                    this.$toast(rej.message);
                }
            )            
        },        
        buy (){
            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();

            if(this.teaminfo.length != this.max)return this.$toast('当前不符合购买条件哦~');

            if(this.$store.state.tokeninfo.teamBuy == 0)return this.$toast('不能购买了哦~');

            this.$comfirm_buy();
        },
        is_Luck(code){
            return this.result.indexOf(code) > -1 ? true : false;
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/views/team.vue